import Link from 'next/link';
import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconCompleted,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { Routes } from '~/constants/routes';
import { type GetCompletedMetadata, type LibraryDeletionTask } from '~/store/tasks/types';

export type DuplicateBoardCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<LibraryDeletionTask>;
  onClear: () => void;
};

export const DeleteLibraryCompletedPanelItem = memo(({ onClear }: DuplicateBoardCompletedPanelItemProps) => {
  return (
    <PaneItemTW
      truncate={false}
      avatar={<FileStatusIconCompleted />}
      title={<FileStatusTitle>Deleted successfully</FileStatusTitle>}
      subtitle={
        <FileStatusSubtitle className="truncate">
          Library moved to{' '}
          <Link
            href={Routes.media.recentlyDeleted}
            className="cursor-pointer font-semibold text-altitude-9 hover:text-altitude-11 hover:underline"
          >
            Recently deleted
          </Link>
        </FileStatusSubtitle>
      }
      buttons={
        <FileStatusButton label="Clear" onClick={onClear}>
          <Close className="size-4" />
        </FileStatusButton>
      }
    />
  );
});

DeleteLibraryCompletedPanelItem.displayName = 'DeleteLibraryCompletedPanelItem';
